import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Angular's built-in `Validators.email` accepts addresses whose domain has no top-level
 * domain — e.g. `11@sdsa`, `jane@example`, `user@localhost` all pass. This validator adds the
 * missing constraint: the domain must end in a dot followed by a TLD of at least two letters.
 *
 * Compose it with `Validators.email`, which still handles overall structure, length, and the
 * local-part charset. It returns the same `email` error key so no extra message/i18n is needed,
 * and returns null for empty values so `Validators.required` owns emptiness.
 */
export function emailTldValidator(): ValidatorFn {
  const tldRegex = /\.[a-zA-Z]{2,}$/;

  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value || typeof value !== 'string') {
      return null;
    }

    const domain = value.split('@')[1] ?? '';
    return tldRegex.test(domain) ? null : { email: true };
  };
}
